// Avisos do jogo: card de confirmação (nunca toast do site)
const listeners = new Set();

export const onNotice = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

const emit = (n) => listeners.forEach((fn) => fn({ id: `${Date.now()}-${Math.random()}`, ...n }));

export const gameNotice = {
  ok: (title, desc, icon) => emit({ kind: 'ok', title, desc, icon }),
  fail: (title, desc) => emit({ kind: 'fail', title, desc }),
};
